export const translation = {
  zenit: {
    ae: {
      siteTitle: "مكافآتك | Zenit",
      subtitle: "فز",
      title: "بالجائزة",
      titleExtra: "الكبرى",
      text: "توقع المجموعة الفائزة!",
      btnText: 'أوقف العجلة',
      modal: {
        title: "تهانينا!",
        bonusTitle: "مكافأة",
        getBtnText: "احصل على مكافأتك",
        rulesBtnText: "الشروط والأحكام",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    bn: {
      siteTitle: "আপনার বোনাস | Zenit",
      subtitle: "জ্যাকপট",
      title: "জিতুন",
      text: "বিজয়ী কম্বো অনুমান করুন!",
      btnText: 'চাকা থামান',
      modal: {
        title: "অভিনন্দন!",
        bonusTitle: "বোনাস",
        getBtnText: "আপনার বোনাস পান",
        rulesBtnText: "শর্তাবলী",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    br: {
      siteTitle: "Seus bônus | Zenit",
      subtitle: "FATURE",
      title: "O JACKPOT",
      text: "ADIVINHE O COMBO VENCEDOR!",
      btnText: 'Parar a roleta',
      modal: {
        title: "PARABÉNS!",
        bonusTitle: "BÔNUS",
        getBtnText: "Colete seu bônus",
        rulesBtnText: "Regras",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    de: {
      siteTitle: "Ihre Boni | Zenit",
      subtitle: "GEWINNEN SIE",
      title: "DEN",
      titleExtra: "JACKPOT",
      text: "ERRATEN SIE DIE GEWINNKOMBINATION!",
      btnText: 'Stoppen Sie das Rad',
      modal: {
        title: "GLÜCKWUNSCH!",
        bonusTitle: "BONUS",
        getBtnText: "Holen Sie sich Ihren Bonus",
        rulesBtnText: "Regeln",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    en: {
      siteTitle: "Your bonuses | Zenit",
      subtitle: "WIN",
      title: "THE JACKPOT",
      text: "GUESS THE WINNING COMBO!",
      btnText: 'Stop the wheel',
      modal: {
        title: "CONGRATULATIONS!",
        bonusTitle: "BONUS",
        getBtnText: "Get your bonus",
        rulesBtnText: "Rules",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    fr: {
      siteTitle: "Vos bonus | Zenit",
      subtitle: "GAGNEZ",
      title: "LE JACKPOT",
      text: "DEVINEZ LA COMBINAISON GAGNANTE!",
      btnText: 'Arrêter la roue',
      modal: {
        title: "FÉLICITATIONS!",
        bonusTitle: "BONUS",
        getBtnText: "Obtenir votre bonus",
        rulesBtnText: "Conditions générales",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    ir: {
      siteTitle: "برنده جک‌پات شو | کازینو | ZENIT",
      subtitle: "برد",
      title: "جک‌پات",
      text: "حدس بزن ترکیب برنده رو!",
      btnText: 'توقف چرخ',
      modal: {
        title: "تبریک!",
        bonusTitle: "پاداش",
        getBtnText: "پاداشت رو بگیر",
        rulesBtnText: "قوانین",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    kz: {
      siteTitle20: "Джекпотты ұтып алу | Казино | ZENIT",
      siteTitle25: "Бастапқы бонус | ZENIT БК",
      subtitle: "ҰТЫП АЛ",
      title: "ДЖЕКПОТ",
      text: "ҰТЫС КОМБИНАЦИЯСЫН АЛ!",
      btnText: 'Барабанды тоқтату',
      modal: {
        title: "БАҒЫҢ БАР ЕКЕН!",
        bonusTitle: "БОНУС",
        getBtnText: "Бонусты алу",
        rulesBtnText: "Еережелер",
        footnoteText: '*подробнее в Правилах',
      }
    },
    mx: {
      siteTitle: "Sus bonificaciones | Zenit",
      subtitle: "GANE",
      title: "EL PREMIO",
      titleExtra: "MAYOR",
      text: "¡ADIVINE LA COMBINACIÓN GANADORA!",
      btnText: 'Detenga la rueda',
      modal: {
        title: "¡FELICITACIONES!",
        bonusTitle: "BONIFICACIÓN DE",
        getBtnText: "Obtenga su bonificación",
        rulesBtnText: "Reglas",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    ru: {
      siteTitle20: "Сорви джекпот | ZENIT",
      siteTitle25: "Лови джекпот | Казино | ZENIT",
      subtitle: "Выиграй",
      title: "Джекпот",
      text: "Получи выигрышную комбинацию!",
      btnText: 'Остановить барабан',
      modal: {
        title: "Счастливчик!",
        bonusTitle: "Бонус",
        getBtnText: "Забрать бонус",
        rulesBtnText: "Правила",
        footnoteText: '*подробнее в Правилах',
      }
    },
    sw: {
      siteTitle: "Bonasi zako | Zenit",
      subtitle: "JISHINDIE",
      title: "USHINDI",
      titleExtra: "MKUU",
      text: "BASHIRI TIMU INAYOSHINDA!",
      btnText: 'Simamisha gurudumu',
      modal: {
        title: "HONGERA!",
        bonusTitle: "BONASI",
        getBtnText: "Pokea bonasi yako",
        rulesBtnText: "SHERIA NA\xA0MASHARTI",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    tr: {
      siteTitle: "Bonuslarınız | Zenit",
      subtitle: "BÜYÜK",
      title: "ÖDÜLÜ",
      titleExtra: "KAZAN",
      text: "KAZANAN KOMBİNASYONU TAHMİN ET!",
      btnText: 'Çarkı durdur',
      modal: {
        title: "TEBRİKLER!",
        bonusTitle: "BONUS",
        getBtnText: "Bonusunuzu alın",
        rulesBtnText: "HÜKÜM VE KOŞULLAR",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    ua: {
      siteTitle20: "Сорви джекпот | Казино | ZENIT",
      siteTitle25: "Лови джекпот | Казино | ZENIT",
      subtitle: "Выиграй",
      title: "Джекпот",
      text: "Получи выигрышную комбинацию!",
      btnText: 'Остановить барабан',
      modal: {
        title: "Счастливчик!",
        bonusTitle: "Бонус",
        getBtnText: "Забрать бонус",
        rulesBtnText: "Правила",
        footnoteText: '*подробнее в Правилах',
      }
    },
    uz: {
      siteTitle: "Bonuslaring | Zenit",
      subtitle: "YUTIB OL",
      title: "JEKPOTNI",
      text: "YUTUQLI KOMBINATSIYANI OL!",
      btnText: 'Barabanni to‘xtatish',
      modal: {
        title: "OMADLI ODAM!",
        bonusTitle: "BONUS",
        getBtnText: "Bonus olish",
        rulesBtnText: "QOIDALAR",
        footnoteText: '*подробнее в Правилах',
      }
    },
    vi: {
      siteTitle: "Tiền thưởng của bạn | Zenit",
      subtitle: "GIÀNH",
      title: "GIẢI",
      titleExtra: "ĐỘC ĐẮC",
      text: "ĐOÁN COMBO CHIẾN THẰNG!",
      btnText: 'Dừng vòng quay',
      modal: {
        title: "XIN CHÚC MỪNG!",
        bonusTitle: "TIỀN THƯỞNG",
        getBtnText: "Nhận tiền thưởng",
        rulesBtnText: "Điều khoản và\xA0điều\xA0kiện",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    }
  },
  zenbet: {
    ae: {
      siteTitle: "مكافآتك | «ZENBET»",
      subtitle: "فز",
      title: "بالجائزة",
      titleExtra: "الكبرى",
      text: "توقع المجموعة الفائزة!",
      btnText: 'أوقف العجلة',
      modal: {
        title: "تهانينا!",
        bonusTitle: "مكافأة",
        getBtnText: "احصل على مكافأتك",
        rulesBtnText: "الشروط والأحكام",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    bn: {
      siteTitle: "আপনার বোনাস | «ZENBET»",
      subtitle: "জ্যাকপট",
      title: "জিতুন",
      text: "বিজয়ী কম্বো অনুমান করুন!",
      btnText: 'চাকা থামান',
      modal: {
        title: "অভিনন্দন!",
        bonusTitle: "বোনাস",
        getBtnText: "আপনার বোনাস পান",
        rulesBtnText: "শর্তাবলী",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    br: {
      siteTitle: "Bônus de boas-vindas | Bookmaker «ZENBET»",
      subtitle: "FATURE",
      title: "O JACKPOT",
      text: "ADIVINHE O COMBO VENCEDOR!",
      btnText: 'Parar a roleta',
      modal: {
        title: "PARABÉNS!",
        bonusTitle: "BÔNUS",
        getBtnText: "Colete seu bônus",
        rulesBtnText: "Regras",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    de: {
      siteTitle: "Ihre Boni | «ZENBET»",
      subtitle: "GEWINNEN SIE",
      title: `DEN`,
      titleExtra: `JACKPOT`,
      text: "ERRATEN SIE DIE GEWINNKOMBINATION!",
      btnText: 'Stoppen Sie das Rad',
      modal: {
        title: "GLÜCKWUNSCH!",
        bonusTitle: "BONUS",
        getBtnText: "Holen Sie sich Ihren Bonus",
        rulesBtnText: "Regeln",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    en: {
      siteTitle: "Jackpot | Casino | «ZENBET»",
      subtitle: "WIN",
      title: "THE JACKPOT",
      text: "GUESS THE WINNING COMBO!",
      btnText: 'Stop the wheel',
      modal: {
        title: "CONGRATULATIONS!",
        bonusTitle: "BONUS",
        getBtnText: "Get your bonus",
        rulesBtnText: "Rules",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    fr: {
      siteTitle: "Vos bonus | «ZENBET»",
      subtitle: "GAGNEZ",
      title: "LE JACKPOT",
      text: "DEVINEZ LA COMBINAISON GAGNANTE!",
      btnText: 'Arrêter la roue',
      modal: {
        title: "FÉLICITATIONS!",
        bonusTitle: "BONUS",
        getBtnText: "Obtenir votre bonus",
        rulesBtnText: "Conditions générales",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    ir: {
      siteTitle: "برنده جک‌پات شو | کازینو | «ZENBET»",
      subtitle: "برد",
      title: "جک‌پات",
      text: "حدس بزن ترکیب برنده رو!",
      btnText: 'توقف چرخ',
      modal: {
        title: "تبریک!",
        bonusTitle: "پاداش",
        getBtnText: "پاداشت رو بگیر",
        rulesBtnText: "قوانین",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    kz: {
      siteTitle: "Сенің бонустарың | БК «ZENBET»",
      subtitle: "ҰТЫП АЛ",
      title: "ДЖЕКПОТ",
      text: "ҰТЫС КОМБИНАЦИЯСЫН АЛ!",
      btnText: 'Барабанды тоқтату',
      modal: {
        title: "БАҒЫҢ БАР ЕКЕН!",
        bonusTitle: "БОНУС",
        getBtnText: "Бонусты алу",
        rulesBtnText: "Еережелер",
        footnoteText: '*подробнее в Правилах',
      }
    },
    mx: {
      siteTitle: "Bonificación de bienvenida | Bookmaker «ZENBET»",
      subtitle: "GANE",
      title: "EL PREMIO",
      titleExtra: "MAYOR",
      text: "¡ADIVINE LA COMBINACIÓN GANADORA!",
      btnText: 'Detenga la rueda',
      modal: {
        title: "¡FELICITACIONES!",
        bonusTitle: "BONIFICACIÓN DE",
        getBtnText: "Obtenga su bonificación",
        rulesBtnText: "Reglas",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    ru: {
      siteTitle: "Твои бонусы | БК «ZENBET»",
      subtitle: "Выиграй",
      title: "Джекпот",
      text: "Получи выигрышную комбинацию!",
      btnText: 'Остановить барабан',
      modal: {
        title: "Счастливчик!",
        bonusTitle: "Бонус",
        getBtnText: "Забрать бонус",
        rulesBtnText: "Правила",
        footnoteText: '*подробнее в Правилах',
      }
    },
    sw: {
      siteTitle: "Bonasi zako | «ZENBET»",
      subtitle: "JISHINDIE",
      title: "USHINDI",
      titleExtra: "MKUU",
      text: "BASHIRI TIMU INAYOSHINDA!",
      btnText: 'Simamisha gurudumu',
      modal: {
        title: "HONGERA!",
        bonusTitle: "BONASI",
        getBtnText: "Pokea bonasi yako",
        rulesBtnText: "SHERIA NA\xA0MASHARTI",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    },
    tr: {
      siteTitle: "Bonuslarınız | «ZENBET»",
      subtitle: "BÜYÜK",
      title: "ÖDÜLÜ",
      titleExtra: "KAZAN",
      text: "KAZANAN KOMBİNASYONU TAHMİN ET!",
      btnText: 'Çarkı durdur',
      modal: {
        title: "TEBRİKLER!",
        bonusTitle: "BONUS",
        getBtnText: "Bonusunuzu alın",
        rulesBtnText: "HÜKÜM VE KOŞULLAR",
        footnoteText: '*read more in Terms and Conditions of the Promotion',

      }
    },
    uz: {
      siteTitle: "Bonuslaring | «ZENBET»",
      subtitle: "YUTIB OL",
      title: "JEKPOTNI",
      text: "YUTUQLI KOMBINATSIYANI OL!",
      btnText: 'Barabanni to‘xtatish',
      modal: {
        title: "OMADLI ODAM!",
        bonusTitle: "BONUS",
        getBtnText: "Bonus olish",
        rulesBtnText: "QOIDALAR",
        footnoteText: '*подробнее в Правилах',
      }
    },
    vi: {
      siteTitle: "Tiền thưởng của bạn | «ZENBET»",
      subtitle: "GIÀNH",
      title: "GIẢI",
      titleExtra: "ĐỘC ĐẮC",
      text: "ĐOÁN COMBO CHIẾN THẰNG!",
      btnText: 'Dừng vòng quay',
      modal: {
        title: "XIN CHÚC MỪNG!",
        bonusTitle: "TIỀN THƯỞNG",
        getBtnText: "Nhận tiền thưởng",
        rulesBtnText: "Điều khoản và\xA0điều\xA0kiện",
        footnoteText: '*read more in Terms and Conditions of the Promotion',
      }
    }
  }
}
